import { getCustomerTicketsAnalytics } from "entities/customerTickets/api/getCustomerTicketsAnalytics";
import { CustomerTicketAnalytics } from "entities/customerTickets/types";
import { useState, useEffect } from "react";

export const useAnalyticsData = () => {
  const [data, setData] = useState<CustomerTicketAnalytics>({
    lastWeekTotalInquiries: 0,
    thisWeekTotalInquiries: 0,
    weeklyDifferencePercentage: 0,
    thisWeekAverageResponseTime: 0,
    lastWeekAverageResponseTime: 0,
    inquiriesByCategory: [],
    weeklyResponseTimeDifferencePercentage: 0,
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = getCustomerTicketsAnalytics((newData) => {
      const sortedData = {
        ...newData,
        inquiriesByCategory: [...newData.inquiriesByCategory].sort((a, b) => {
          if (b.thisWeekCount !== a.thisWeekCount) {
            return b.thisWeekCount - a.thisWeekCount;
          }
          return a.category.localeCompare(b.category);
        }),
      };

      setData(sortedData);
      setIsLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return {
    ...data,
    isLoading,
  };
};
